import React, { MouseEventHandler } from 'react';
import styled from '@emotion/styled';

import { BulletPoint, ComponentStyle, ProductCTA } from '../../../types/types';
import { PrimaryButton } from '../../shared/Buttons';
import { CtaHeader } from '../CtaHeader';
import { StyleLibrary } from '@vm/omega-shared-component-webapp';
const { mqBreakpoints, pxToRem } = StyleLibrary;

import { productComponentContainerPaddingStyle, productComponentContainerBottomPaddingStyle } from '../../shared/styles';
import { CtaTpLogo } from './CtaTpLogo';
import { CtaTpPoints } from './CtaTpPoints';
import { CtaTpSummaryPoints } from './CtaTpSummaryPoints';
import { CtaButton } from '../CtaButton';
import { isDark } from '../../../utils/colours';

const CtaTpContentContainerStyle = styled.div(productComponentContainerPaddingStyle, productComponentContainerBottomPaddingStyle, {
  alignItems: 'flex-start',

  '&.F': {
    background: '#F3F3F3',
    alignItems: 'flex-start',
    paddingTop: pxToRem(80),
    width: '100%',
  },

  '&:not(.F)': {
    button: {
      minWidth: pxToRem(192),
    },
  },

  [mqBreakpoints.tablet]: {
    '&.F': {
      alignItems: 'center',
    },
  },

  [mqBreakpoints.desktop]: {
    paddingTop: pxToRem(112),
    paddingBottom: pxToRem(16),
  },
});

type Props = {
  title?: string;
  logo?: string;
  points?: BulletPoint[];
  style: ComponentStyle;
  cta?: ProductCTA;
  paletteBackgroundColor?: string;
  paletteTextColor?: string;
  description?: string;
  onCtaClick?: () => void;
};

export const CtaTpContentContainer: React.FC<Props> = ({ style, title, description, cta, paletteBackgroundColor, paletteTextColor, logo, points, onCtaClick }) => {
  const isSolidBG = !!paletteBackgroundColor && paletteBackgroundColor.startsWith('#');
  const isBGDark = (style === ComponentStyle.E && isSolidBG && isDark(paletteBackgroundColor)) || cta?.isWhite || (style !== ComponentStyle.E && !!paletteBackgroundColor);
  return (
    <CtaTpContentContainerStyle className={style} style={{ background: paletteBackgroundColor, color: paletteTextColor }}>
      {logo && <CtaTpLogo logo={logo} />}
      {title && <CtaHeader title={title} strapline={description} style={style} />}
      {style === ComponentStyle.F ? points && <CtaTpSummaryPoints points={points} /> : points && <CtaTpPoints points={points} />}
      {cta && <CtaButton bgDark={isBGDark} title={cta.buttonText} onClick={onCtaClick} />}
    </CtaTpContentContainerStyle>
  );
};
